import Vue from 'vue';
import Vuex from 'vuex';
// import { required, minLength, between } from "vuelidate/lib/validators";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    home_page: {
      sections: [
        {
          type: 'jumbotron',
          id: 'home-1',
          content: {
            text:
              `<h1 class="title">A driven, professional technical sales organization serving the Northeast U.S. marketplace for over 60 years.</h1>
              <br/>`,
            image: 'jumbotron.jpg',
            buttonText: 'About Us',
            buttonLink: '/about',
          },
        },
        {
          type: 'icons',
          id: 'home-2',
          content: {
            text:
              `<h1 class="title">SJ Associates delivers.</h1>
              <br/>
              <p>For more than 60 years, SJ Associates has been providing the most effective sales representation for leading semiconductor suppliers for the NE Region of the US. We deploy the most experienced and professional technical team in the industry.</p>`,
            icons: [
              {
                id: 'icon-1',
                image: 'people.png',
                caption: 'Self-driven, reliable and distinguished representation.​',
              },
              {
                id: 'icon-2',
                image: 'list.png',
                caption: 'Ability to manage and orchestrate complex breakthrough deals across global organizations with diverse teams.​',
              },
              {
                id: 'icon-3',
                image: 'antenna.png',
                caption: 'A network of relationships that delivers quick deployment of new technology.​',
              },
            ],
          },
        },
        {
          type: 'cta',
          id: 'home-3',
          align: 'left',
          content: {
            text:
              `<h1 class="title title-white">Our Services</h1>
              <br/>
              <p>Providing technology for the next generation.</p>
              <br/>`,
            buttonText: 'Learn More',
            buttonLink: '/about',
          },
        },
        {
          type: 'cta',
          id: 'home-4',
          align: 'right',
          content: {
            text:
              `<h1 class="title title-white">Join Our Team</h1>
              <br/>
              <p>Seeking your next challenge? Join our team.</p>
              <br/>`,
            buttonText: 'Learn More',
            buttonLink: '/about',
          },
        },
      ],
    },
    about_page: {
      sections: [
        {
          type: 'jumbotron',
          id: 'about-1',
          content: {
            text:
              `<h1 class="title">About page</h1>
              <br/>
              <div class="subtitle">Under construction</div>`,
            image: '',
          },
        },
      ],
    },
    services_page: {
      sections: [
        {
          type: 'jumbotron',
          id: 'services-1',
          content: {
            text: '<h1 class="title">Our Services</h1><br/><p>SJ Associates offers best-in-class manufacturer’s representation to the benefit of the manufacturer and our customer base. Our in-depth knowledge of our territory allows us to properly align design needs with the correct products, allowing us to drive strong relationships between the customer and manufacturer on a consistent, meaningful basis.​</p>',
            image: 'services.png',
          },
        },
        {
          type: 'gallery',
          id: 'services-2',
          content: [
            {
              id: 'what',
              text:
                `<h1 class="title title-white">What We Sell</h1>
                <br/>
                <p>SJ represents world class manufacturers that support the majority of PCB and other electronic design requirements.</p>`,
              items: [
                {
                  id: 0,
                  label: 'Power',
                  description: 'DC/DC, AC/DC, discretes, Silicon Carbide Gate Drivers, Controllers, Optocouplers, Magnetics, PoE, Digital Isolation, Relays, Contactors​',
                  icon: 'power.png',
                },
                {
                  id: 1,
                  label: 'Wireless & RF',
                  description: 'BLE, Zigbee, Thread, Z-Wave, Proprietary, WiFi, GPS, Cellular, FEMs, LNAs, Power Amplifiers, Switches, Filters​',
                  icon: 'wireless.png',
                },
                {
                  id: 2,
                  label: 'Circuit Protection',
                  description: 'Fuses, MOVs, Surge Protection Modules, Thyristors, PTCs​',
                  icon: 'circuit-protector.png',
                },
                {
                  id: 3,
                  label: 'Timing',
                  description: 'Clock generators, Buffers, Jitter attenuators, Crystal oscillators​',
                  icon: 'timing.png',
                },
                {
                  id: 4,
                  label: 'Sensors',
                  description: 'Relative Humidity, Temperature, Pressure, Gas, Optical, Proximity, Magnetic, Accelerometers, Gyroscopes, IMUs, Absolute Orientation, Image​',
                  icon: 'sensor.png',
                },
                {
                  id: 5,
                  label: 'Computing & Logic',
                  description: 'MCUs, CPUs, GPUs, APUs',
                  icon: 'logic.png',
                },
                {
                  id: 6,
                  label: 'Memory',
                  description: 'DRAM modules/chips, Flash chips, SRAM chips SD cards, Micro SD cards, USB Drives, eMMC​',
                  icon: 'memory.png',
                },
                {
                  id: 7,
                  label: 'Audio',
                  description: 'DSPs, Codecs, ADCs, DACs, Microphones, Buzzers​',
                  icon: 'audio.png',
                },
                {
                  id: 8,
                  label: 'Networking',
                  description: 'Antennas, Signal Transformers, Optical Modules, Connectors, Terminal Blocks​',
                  icon: 'networking.png',
                },
              ],
            }, {
              id: 'who',
              text:
                `<h1 class="title title-white">Who We Sell To</h1>
                <br/>
                <p>SJ represents world class manufacturers that support the majority of PCB and other electronic design requirements.</p>`,
              items: [
                {
                  id: 0,
                  label: 'Industrial',
                  icon: 'industrial.png',
                },
                {
                  id: 1,
                  label: 'Military/Aerospace',
                  icon: 'military.png',
                },
                {
                  id: 2,
                  label: 'Appliances',
                  icon: 'appliances.png',
                },
                {
                  id: 3,
                  label: 'Telecomm',
                  icon: 'telecomm.png',
                },
                {
                  id: 4,
                  label: 'Medical',
                  icon: 'medical.png',
                },
                {
                  id: 5,
                  label: 'Lighting',
                  icon: 'lighting.png',
                },
                {
                  id: 6,
                  label: 'Datacenters',
                  icon: 'datacenters.png',
                },
                {
                  id: 7,
                  label: 'Robotics',
                  icon: 'robotics.png',
                },
                {
                  id: 8,
                  label: 'IoT',
                  icon: 'iot.png',
                },
              ],
            }, {
              id: 'how',
              columns: [
                {
                  id: 0,
                  label: 'SJAMs',
                  description: 'SJAMs is the proprietary SJ Associates CRM system. SJAMs allows for constant opportunity tracking from early identification to revenue recognition. Importing from principal CRMs further enables us to capture and analyze opportunities, quotes, orders, POS, and more.',
                  icon: 'power.png',
                },
                {
                  id: 1,
                  label: 'Digital Marketing',
                  description: 'A main practice differentiating SJ Associates from its competition, our investment in digital marketing is increasing our success in the territory. Our self-produced digital marketing campaigns allow us to keep customers up to date on the latest releases and technology trends from our manufacturers.​',
                  icon: 'wireless.png',
                },
                {
                  id: 2,
                  label: 'Continual Training',
                  description: 'With continuous training, our employees are encouraged to strengthen and improve their skillsets on a continual basis. Open communication with management allows for best practices to be instilled from the beginning, and hands-on trainings with our vendors provide the team with ever-evolving knowledge of the technologies we sell.',
                  icon: 'circuit-protector.png',
                },
              ],
            },
          ],
        },
      ],
    },
    contact_page: {
      sections: [
        // {
        //   type: "jumbotron",
        //   id: "contact-1",
        //   content: {
        //     text:
        //       `<h1 class="title">Contact page</h1>
        //       <br/>
        //       <div class="subtitle">Under construction</div>`,
        //     image: "",
        //   }
        // },
        {
          type: 'jumbotron',
          id: 'contact-1',
          content: {
            text:
              '',
            image: 'us-map-2.svg',
          },
        },
      ],
    },
    global: {
      contact_form: {
        status: '',
        fields: [
          {
            label: 'First Name',
            value: '',
            columnsClass: 'is-half-desktop',
            pattern: 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
            validators: {
              required: true,
            },
          },
          {
            label: 'Last Name',
            value: '',
            columnsClass: 'is-half-desktop',
            pattern: 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
            validators: {
              required: true,
            },
          },
          {
            label: 'Email',
            value: '',
            columnsClass: 'is-half-desktop',
            validators: {
              required: true,
              email: true,
            },
          },
          {
            label: 'I am a...',
            value: '',
            columnsClass: 'is-half-desktop',
            inputType: 'select',
            inputOptions: ['Customer', 'Manufacturer', 'Other'],
            validators: {
              required: true,
            },
          },
          {
            label: 'Subject',
            value: '',
            columnsClass: 'is-half-desktop',
            pattern: 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
            validators: {
              required: true,
            },
          },
          {
            label: 'Message',
            value: '',
            columnsClass: 'is-half-desktop',
            pattern: 'SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS',
            validators: {
              required: true,
            },
          },
        ],
      },
      offices: [
        {
          id: 0,
          location: 'New York',
          address: {
            street: '500 North Broadway, Suite 159',
            city: 'Jericho',
            state: 'NY',
            zip: '11753',
          },
          phone: '516-942-3232',
          fax: '516-942-0132',
          established: 1950,
          manager: {
            name: 'Mark Wachtel',
            title: 'President',
            email: 'mwachtel@sjassoc.com',
          },
        },
        {
          id: 1,
          location: 'Chesapeake',
          address: {
            street: '10545 Guilford Rd Suite 100',
            city: 'Jessup',
            state: 'MD',
            zip: '20794',
          },
          phone: '301-470-1596',
          fax: '301-483-0227',
          established: 1987,
          manager: {
            name: 'Jeff Land',
            title: 'Division Manager',
            email: 'jland@sjassoc.com',
          },
        },
        {
          id: 2,
          location: 'Mid Atlantic',
          address: {
            street: '131-E Gaither Drive',
            city: 'Mt. Laurel',
            state: 'NJ',
            zip: '08054',
          },
          phone: '856-866-1234',
          fax: '856-866-8627',
          established: 1984,
          manager: {
            name: 'Dan Rysz',
            title: 'Division Manager',
            email: 'drysz@sjassoc.com',
          },
        },
        {
          id: 3,
          location: 'New England',
          address: {
            street: '33 Boston Post Rd. West Suite 310',
            city: 'Marlboro',
            state: 'MA',
            zip: '01752',
          },
          phone: '508-485-2700',
          fax: '508-485-2702',
          established: 1991,
          manager: {
            name: 'Tom Faherty',
            title: 'Division Manager',
            email: 'tfaherty@sjassoc.com',
          },
        },
      ],
      footer: {
        copyright: '&copy; 2019 SJ Associates. All rights reserved.',
        icons: [
          {
            name: 'facebook',
            url: 'http://www.facebook.com',
          },
          {
            name: 'instagram',
            url: 'http://www.instagram.com',
          },
          {
            name: 'linkedin',
            url: 'http://www.linkedin.com',
          },
        ],
      },
    },
  },
  mutations: {},
  actions: {},
  getters: {
    getProjectByUrl: (state) => (url) => state.work_page.projects.find((project) => project.url === url),
  },
});
